import { render } from "./InfraServiceConfigsTable.vue?vue&type=template&id=14918694&scoped=true"
import script from "./InfraServiceConfigsTable.vue?vue&type=script&lang=js"
export * from "./InfraServiceConfigsTable.vue?vue&type=script&lang=js"

import "./InfraServiceConfigsTable.vue?vue&type=style&index=0&id=14918694&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14918694"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QIcon,QBtn,QTooltip});
